module.exports = {"230108001":"兴建街道","230108002":"保国街道","230108003":"联盟街道","230108004":"友协街道","230108005":"新疆街道","230108006":"新伟街道","230108007":"平新街道","230108008":"建安街道","230108009":"平盛街道","230108101":"平房镇","230108579":"平房农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230108.json
// module id = 764
// module chunks = 0